import React, { useState, useCallback } from 'react';
import { chequeService, extractErrorDetails } from '../services/api';
import ErrorDisplay from './ErrorDisplay';

function ChequesVencimientoDashboard({ onEditCheque }) {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [totalImporte, setTotalImporte] = useState(null);
  const [cheques, setCheques] = useState([]);
  const [pagination, setPagination] = useState({ page: 0, totalPages: 0, totalElements: 0 });
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchDashboard = useCallback(async (page) => {
    setError('');
    setLoading(true);
    try {
      const response = await chequeService.getDashboard(fromDate, toDate, page, 20);
      if (response.success) {
        setTotalImporte(response.data.totalImporte);
        const chequesPage = response.data.cheques;
        setCheques(chequesPage.content || []);
        setPagination({
          page: chequesPage.pageNumber,
          totalPages: chequesPage.totalPages,
          totalElements: chequesPage.totalElements
        });
        setSearched(true);
      } else {
        setError(response.message || 'Error al consultar los vencimientos');
      }
    } catch (err) {
      const { message } = extractErrorDetails(err, 'Error al consultar los vencimientos');
      setError(message);
    } finally {
      setLoading(false);
    }
  }, [fromDate, toDate]);

  const handleBuscar = async (e) => {
    e.preventDefault();
    if (!fromDate || !toDate) {
      setError('Debe seleccionar ambas fechas');
      return;
    }
    fetchDashboard(0);
  };

  const handlePageChange = (newPage) => {
    fetchDashboard(newPage);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Está seguro de eliminar este cheque?')) {
      try {
        const response = await chequeService.deleteCheque(id);
        if (response.success) {
          fetchDashboard(pagination.page);
        } else {
          setError(response.message || 'Error al eliminar el cheque');
        }
      } catch (err) {
        const { message } = extractErrorDetails(err, 'Error al eliminar el cheque');
        setError(message);
      }
    }
  };

  const formatImporte = (importe) => {
    return new Intl.NumberFormat('es-UY', { style: 'currency', currency: 'UYU' }).format(importe);
  };

  return (
    <div className="cheques-vencimiento-dashboard">
      <form onSubmit={handleBuscar} className="filter-row" style={{ alignItems: 'flex-end' }}>
        <div className="filter-group">
          <label htmlFor="fromDate">Desde</label>
          <input
            type="date"
            id="fromDate"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            required
          />
        </div>
        <div className="filter-group">
          <label htmlFor="toDate">Hasta</label>
          <input
            type="date"
            id="toDate"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            required
          />
        </div>
        <div className="filter-group">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Buscando...' : 'Buscar'}
          </button>
        </div>
      </form>

      <ErrorDisplay error={error} />

      {searched && (
        <>
          <div className="report-summary">
            <p>Total a vencer entre {fromDate} y {toDate}: <strong>{formatImporte(totalImporte || 0)}</strong></p>
            <p>{pagination.totalElements} cheque(s) en el período</p>
          </div>

          {cheques.length === 0 ? (
            <div className="empty-state">
              <p>No hay cheques que venzan en ese período</p>
            </div>
          ) : (
            <>
              <div className="cheques-table">
                <table>
                  <thead>
                    <tr>
                      <th>Número</th>
                      <th>Fecha Emisión</th>
                      <th>Fecha Vencimiento</th>
                      <th>Importe</th>
                      <th>Cargado por</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cheques.map((cheque) => (
                      <tr key={cheque.id}>
                        <td>{cheque.numero}</td>
                        <td>{cheque.fechaEmision}</td>
                        <td>{cheque.fechaVencimiento}</td>
                        <td>{formatImporte(cheque.importe)}</td>
                        <td>{cheque.createdByNombre}</td>
                        <td className="actions-cell">
                          <button
                            onClick={() => onEditCheque(cheque)}
                            className="btn btn-small"
                          >
                            Editar
                          </button>
                          <button
                            onClick={() => handleDelete(cheque.id)}
                            className="btn btn-small btn-danger"
                          >
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {pagination.totalPages > 1 && (
                <div className="pagination">
                  <button
                    onClick={() => handlePageChange(pagination.page - 1)}
                    disabled={pagination.page === 0}
                    className="btn btn-small"
                  >
                    Anterior
                  </button>
                  <span>Página {pagination.page + 1} de {pagination.totalPages}</span>
                  <button
                    onClick={() => handlePageChange(pagination.page + 1)}
                    disabled={pagination.page >= pagination.totalPages - 1}
                    className="btn btn-small"
                  >
                    Siguiente
                  </button>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}

export default ChequesVencimientoDashboard;
